
import { Button } from "components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu"
import { MoreHorizontal } from "lucide-react";

export const TIMEFRAME_OPTIONS = [
  { label: "Last 7 days", value: "7d" },
  { label: "Last 28 days", value: "28d" },
  { label: "Last 3 months", value: "3m" },
  { label: "Last Year", value: "1y" },
  { label: "All Time", value: "all" },
];

interface DashboardDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  options?: { label: string; value: string }[];
}

const DashboardDropdown = ({
  value = "28d",
  onChange,
  options = TIMEFRAME_OPTIONS,
}: DashboardDropdownProps) => {
  const selectedLabel = options.find((opt) => opt.value === value)?.label || "Select";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-7 px-2 flex items-center gap-1 bg-transparent border-default-300 hover:bg-default-100 text-default-600 font-normal"
        >
          <span className="text-xs">{selectedLabel}</span>
          <MoreHorizontal className="w-3 h-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[140px] p-0">
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onChange?.(option.value)}
            className={`py-2 rounded-none border-b border-default-200 text-default-900 focus:bg-default-100 dark:focus:text-default-900 ${value === option.value ? "bg-default-100 font-medium" : ""
              }`}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DashboardDropdown;